"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlatNumberSuggest = void 0;
var _filters = require("../filters");
var _types = require("./types");
var _actionGenerator = require("../../utils/actionGenerator");
var _getFlatNumberSuggest = require("../../repositories/price-estimator/my-home/v1/get-flat-number-suggest");
var _selectors = require("../../selectors");
var _getFlatAreasSuggest = require("../getFlatAreasSuggest");
const {
  FLAT_NUMBER_SUCCESS_RESPONSE: SET_SUCCESS
} = _types.EActionTypes;
const setFlatNumberResponseSuccess = (0, _actionGenerator.actionGenerator)(SET_SUCCESS);
const getFlatNumberSuggest = flatNumber => {
  return (dispatch, getState, context) => {
    const {
      httpApi,
      logger
    } = context;
    const {
      houseId
    } = (0, _selectors.selectFilters)(getState());
    return (0, _getFlatNumberSuggest.fetchPublicMyHomeV1GetFlatNumberSuggest)({
      httpApi,
      parameters: {
        houseId: houseId,
        flatNumber
      }
    }).then(response => {
      if (response.statusCode === 200) {
        const {
          area,
          roomsCount
        } = response.response;
        if (area) {
          // Если данные есть
          dispatch((0, _filters.setArea)({
            area
          })); //Устанавливаем колличество комнат
          dispatch((0, _filters.setRooms)({
            roomsCount
          })); // Если данные есть - заполняем/Если нет - отчищаем
          dispatch((0, _getFlatAreasSuggest.setFlatAreaResponse)({
            flatAreas: undefined
          })); // Отчищаем данные о комнатности из стора
        } else {
          // Кейс на случай чейджа инпута - если по одной квартире были а по другой нет
          dispatch((0, _filters.setArea)({
            area
          })); // Отчищаем поле
          dispatch((0, _filters.setRooms)({
            roomsCount
          })); // Отчищаем поле
        }
      }
      return Promise.reject(response);
    }).catch(response => {
      logger.error(response);
    }).finally(() => dispatch(setFlatNumberResponseSuccess(true)));
  };
};
exports.getFlatNumberSuggest = getFlatNumberSuggest;